import {FC, useMemo} from "react";
import ListItem from "@mui/material/ListItem";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemIcon from "@mui/material/ListItemIcon";
import WhatsAppIcon from "@mui/icons-material/WhatsApp";
import FacebookIcon from "@mui/icons-material/Facebook";
import LinkedInIcon from "@mui/icons-material/LinkedIn";
import HelpButton from "../../base/HelpButton.tsx";
import Stack from "@mui/material/Stack";
import Box from "@mui/material/Box";

const isMobileOrTablet = (): boolean =>
    /(android|iphone|ipad|mobile)/i.test(navigator.userAgent);

type ShareButtonsProps = {
    name: string
    isPublic: boolean
}

const ShareButtons: FC<ShareButtonsProps> = ({name, isPublic}) => {
    const whatsappLink = useMemo(() => {
        return 'https://' +
            (isMobileOrTablet() ? 'api' : 'web') +
            '.whatsapp.com/send?' +
            new URLSearchParams({
                text: `Ik nodig je van harte uit om de herinneringspagina van ${name} te bekijken: ${window.location.href}`
            }).toString()
    }, [name]);

    const facebookLink = useMemo(() => {
        return 'https://www.facebook.com/sharer/sharer.php?' + new URLSearchParams({
            u: window.location.href
        }).toString()
    }, []);

    const linkedinLink = useMemo(() => {
        return 'https://linkedin.com/shareArticle?' + new URLSearchParams({
            url: window.location.href,
            mini: 'true',
            title: `herinneringspagina van ${name}`,
            summary: `Ik nodig je van harte uit om de herinneringspagina van ${name} te bekijken.`,
        })
    }, [name]);

    return (
        <ListItem disablePadding>
            <Stack justifyContent="center" width="100%" direction="row">
                <Box position="relative">
                    <ListItemButton sx={{display: "flex", justifyContent: "center"}} href={whatsappLink} target="_blank">
                        <ListItemIcon sx={{minWidth: "auto"}}>
                            <WhatsAppIcon/>
                        </ListItemIcon>
                    </ListItemButton>
                    <HelpButton
                        help="Deel deze herinneringspagina eenvoudig via WhatsApp met vrienden en familie."
                        absolutePosition
                        offsetTop={-1}
                        offsetRight={-1}
                    />
                </Box>
                <Box position="relative">
                    <ListItemButton sx={{display: "flex", justifyContent: "center"}} href={facebookLink} target="_blank" disabled={!isPublic}>
                        <ListItemIcon sx={{minWidth: "auto"}}>
                            <FacebookIcon/>
                        </ListItemIcon>
                    </ListItemButton>
                    <HelpButton
                        help={isPublic ? "Deel deze herinneringspagina eenvoudig via Facebook met vrienden en familie." : "Om deze herinneringspagina te kunnen delen via Facebook, moet de pagina eerst publiek toegankelijk worden gemaakt."}
                        absolutePosition
                        offsetTop={-1}
                        offsetRight={-1}
                    />
                </Box>
                <Box position="relative">
                    <ListItemButton sx={{display: "flex", justifyContent: "center"}} href={linkedinLink} target="_blank" disabled={!isPublic}>
                        <ListItemIcon sx={{minWidth: "auto"}}>
                            <LinkedInIcon/>
                        </ListItemIcon>
                    </ListItemButton>
                    <HelpButton
                        help={isPublic ? "Deel deze herinneringspagina eenvoudig via LinkedIn met uw netwerk." : "Om deze herinneringspagina te kunnen delen via LinkedIn, moet de pagina eerst publiek toegankelijk worden gemaakt."}
                        absolutePosition
                        offsetTop={-1}
                        offsetRight={-1}
                    />
                </Box>
            </Stack>
        </ListItem>
    )
}

export default ShareButtons
